import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import CustomFavoriteButton from 'designer/component/element/FavoriteButton'

export const FavoriteButtonSystem = (props) => (
  <DragElementWrapper {...props}>
    <CustomFavoriteButton {...props} />
  </DragElementWrapper>
)

export const FavoriteButtonDisplay = (props) => (
  <ElementWrapper {...props}>
    <CustomFavoriteButton {...props} />
  </ElementWrapper>
)

export const favoriteButtonTester = rankWith(
  1000,
  scopeEndsWith('favoriteButton'),
)
